import {
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  CheckInFlightIdObjectRepository,
  combineCheckInFlightIdObjects,
  combineContacts,
  combineJourneys,
  combineJourneyTravelers,
  createJourney,
  createJourneyElement,
  EligibilityRepository,
  EmailRepository,
  FrequentFlyerCardRepository,
  JourneyElementCommonRepository,
  JourneyElementRepository,
  JourneyTravelerRepository,
  MockCheckInFlightIdObject,
  MockJourney,
  MockJourneyTraveler,
  PhoneRepository,
  RecursivePartial,
} from '@dapi/sdk/spec';

export const travelers: MockJourneyTraveler[] = combineJourneyTravelers([JourneyTravelerRepository.MAN, JourneyTravelerRepository.WOMAN, JourneyTravelerRepository.INF], {}).items;

export const travelerIds: string[] = travelers.filter(({id}) => !!id).map(({id}) => id);

export const journeyTemplate: RecursivePartial<Journey> = {
  contacts: combineContacts([EmailRepository.DEFAULT, PhoneRepository.DEFAULT], {
    travelerIds
  }).items,
  travelers
};

export const flights: MockCheckInFlightIdObject[] = combineCheckInFlightIdObjects([CheckInFlightIdObjectRepository.NCE_LHR]).items;

export const journeys: MockJourney[] = combineJourneys([
  {
    ...journeyTemplate,
    flights: [flights[0]],
    journeyElements: [
      {
        ...JourneyElementCommonRepository.DEFAULT,
        journeyElement: createJourneyElement({
          template: {
            frequentFlyerCard: FrequentFlyerCardRepository.DEFAULT
          }
        })
      },
      {
        ...JourneyElementCommonRepository.DEFAULT,
        journeyElement: createJourneyElement({
          template: {
            acceptanceEligibility: EligibilityRepository.REGULATORY
          }
        })
      }
    ]
  }
]).items;

export const chosenJourney: MockJourney = journeys[0];

export const validRegulatoryChoosenJourney: MockJourney = createJourney({
  template: {
    ...chosenJourney,
    journeyElements: [chosenJourney.journeyElements[0], {
      ...chosenJourney.journeyElements[1],
      journeyElement: JourneyElementRepository.DEFAULT
    }, chosenJourney.journeyElements[2]]
  }
});

export const acceptedChoosenJourney: MockJourney = createJourney({
  template: {
    ...chosenJourney,
    acceptance: AcceptanceRepository.ACCEPTED
  }
});

export const journeyElementIds: string[] = chosenJourney.journeyElements.map((je: JourneyElementCommon) => je.id);
